import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, flow, observable } from "mobx";
import { BaseOptions } from "@devowl-wp/utils";
import { request } from "../utils/request.js";
import { locationRestChecklistGet } from "../wp-api/checklist.get.js";
import { locationRestChecklistPut } from "../wp-api/checklist.put.js";
class ChecklistStore extends BaseOptions {
    constructor(rootStore){
        super();
        this.busyChecklist = false;
        this.probablyFetchByChangedItem = flow(function*(itemId, force) {
            if (force) {
                yield this.fetchChecklist();
                return;
            }
            const useItemIds = !Array.isArray(itemId) ? [
                itemId
            ] : itemId;
            if (this.items.filter((param)=>{
                let { id, checked } = param;
                return useItemIds.indexOf(id) > -1 && !checked;
            }).length > 0) {
                yield this.fetchChecklist();
            }
        });
        this.fetchChecklist = flow(function*() {
            this.busyChecklist = true;
            try {
                this.checklist = yield request({
                    location: locationRestChecklistGet,
                    sendReferer: true
                });
            } catch (e) {
                console.log(e);
                throw e;
            } finally{
                this.busyChecklist = false;
            }
        });
        this.toggleChecklistItem = flow(function*(id, state) {
            this.busyChecklist = true;
            try {
                this.checklist = yield request({
                    location: locationRestChecklistPut,
                    request: {
                        state
                    },
                    sendReferer: true,
                    params: {
                        id
                    }
                });
            } catch (e) {
                console.log(e);
                throw e;
            } finally{
                this.busyChecklist = false;
            }
        });
        this.rootStore = rootStore;
    }
    get items() {
        return this.checklist && Object.keys(this.checklist.items).map((id)=>({
                id,
                ...this.checklist.items[id]
            })) || [];
    }
    get completed() {
        return this.items.filter((param)=>{
            let { checked } = param;
            return checked;
        });
    }
    get checkable() {
        const { isPro } = this.rootStore.optionStore.others;
        return this.items.filter((param)=>{
            let { needsPro } = param;
            return !needsPro || isPro && needsPro;
        });
    }
    get done() {
        var _this_checklist;
        return this.completed.length >= this.checkable.length || !!((_this_checklist = this.checklist) == null ? void 0 : _this_checklist.dismissed);
    }
}
_ts_decorate([
    observable
], ChecklistStore.prototype, "busyChecklist", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", typeof ResponseRouteChecklistGet === "undefined" ? Object : ResponseRouteChecklistGet)
], ChecklistStore.prototype, "checklist", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], ChecklistStore.prototype, "items", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], ChecklistStore.prototype, "completed", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], ChecklistStore.prototype, "checkable", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], ChecklistStore.prototype, "done", null);
export { ChecklistStore };
